export const SET_DELTA_TIME = "SET_DELTA_TIME";
export const SET_END_DELTA_TIME = "SET_END_DELTA_TIME";
export const SET_LOOP_ENABLE = "SET_LOOP_ENABLE";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
